import { Button, Modal, Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";

function ApprovePlanModal(props) {
  const positionState = useSelector((state) => state.positionState.value);

  return (
    <Modal
      title={"Approve plan"}
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <div className="flex justify-between w-full items-center mb-3">
        <div>
          <div className="flex items-center mb-1">
            <Tag color="blue">{props.data?.data?.plan_levels?.name}</Tag>
            <Tag>{props.data?.data?.plan_groups?.name}</Tag>
            <div className="text-xs text-gray-400">
              {props.data?.data?.createdOn.slice(0, 10)}
            </div>
          </div>
          {props.data?.data?.title}
        </div>
        <div></div>
      </div>

      <div className="text-xs">Target</div>
      <div className="mb-3">{props.data?.data?.target}</div>

      <div className="text-xs">Description</div>
      <div className="mb-3">{props.data?.data?.description}</div>

      {positionState?.userRole?.name !== "Manager"
        ? props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleReject}>
                Reject
              </Button>
              <Button type="primary" htmlType="submit" onClick={props.handleOk}>
                Approve
              </Button>
            </div>
          )
        : props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleDelete}>
                Delete
              </Button>
            </div>
          )}
    </Modal>
  );
}

export default ApprovePlanModal;
